import { createContext } from "react";

export const IsNightModeOnContext = createContext<boolean>(false);
export const SetIsNightModeOnContext = createContext<
  React.Dispatch<React.SetStateAction<boolean>>
>(() => {});
